import { render, staticRenderFns } from "./SessionsTable.vue?vue&type=template&id=2c1b3ed0&"
import script from "./SessionsTable.vue?vue&type=script&lang=js&"
export * from "./SessionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports